<template>
  <router-link
    :to="{ name: 'Category', params: { slug: category.slug } }"
    :title="category.name"
    class="
      bg-black
      cursor-pointer
      px-2
      pt-2
      pb-3
      rounded-xl
      flex flex-col
      items-center
      justify-center
      hover:bg-accent
      transition-default
    "
  >
    <VueLoadImage class="w-full h-[500px] flex items-center justify-center">
      <template v-slot:image>
        <img
          class="object-cover object-center w-[400px] h-[500px] rounded-lg"
          :src="category.cover_image"
          :alt="category.name"
        />
      </template>
      <template v-slot:preloader>
        <div class="w-full h-full text-secondary bg-black rounded-xl relative">
          <SpinLoader />
        </div>
      </template>
    </VueLoadImage>

    <h3 class="text-center text-2xl font-bold text-secondary mt-3">
      {{ category.name }}
    </h3>
  </router-link>
</template>

<script>
import VueLoadImage from "vue-load-image";
import SpinLoader from "@/components/UI/Loader/SpinLoader";
export default {
  name: "TopCategoryItem",
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  components: {
    VueLoadImage,
    SpinLoader,
  },
};
</script>

<style>
</style>